import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Image } from '@yonderland/andes-react';
import { getImageFromCdn } from '../../../util/ImageUtil';
const ContentListerBanner = ({ image }) => {
    const { imageCdnPrefix } = useAemConfig();
    const getBannerUrl = () => getImageFromCdn(image, imageCdnPrefix, '1680');
    return _jsx(Image, { source: getBannerUrl(), alt: "" });
};
export default ContentListerBanner;
